'use strict';

exports.__esModule = true;
var specialistAutocompleteTransformer = exports.specialistAutocompleteTransformer = function specialistAutocompleteTransformer(specialist) {
	return {
		city: specialist.city,
		doctifyId: specialist.doctifyId,
		id: specialist.id,
		type: specialist.type,
		uriId: specialist.uri_id,
		name: (specialist.prefix ? specialist.prefix + ' ' : '') + specialist.name
	};
};